import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export type ConsentTermSpecialty =
  | "capilar"
  | "laser"
  | "peeling"
  | "preenchimento"
  | "micropigmentacao"
  | string;

export type ConsentTermPurpose = "procedure" | "image_marketing" | string;

export interface ConsentTerm {
  id: number;
  title: string;
  specialty: ConsentTermSpecialty;
  purpose?: ConsentTermPurpose;
  body_text: string;
  is_active: boolean;
  version?: number;
  source_preset_id?: number | null;
  updated_at?: string | null;
}

export interface UpdateConsentTermPayload {
  title?: string;
  body_text?: string;
  is_active?: boolean;
}

export const getConsentTerms = (): Promise<ApiResponse<ConsentTerm[]>> =>
  api.get<ApiResponse<ConsentTerm[]>>("/consent-terms");

export const updateConsentTerm = (
  id: number,
  payload: UpdateConsentTermPayload
): Promise<ApiResponse<ConsentTerm>> =>
  api.update<ApiResponse<ConsentTerm>>(`/consent-terms/${id}`, payload);
